module.exports = __webpack_public_path__ + "media/1x1/ws-3ea6d44f.svg";